import { powerOfAttorneyDescription } from "@sp-crm/core";
import { SpMultiSelectOption } from "./sp-multi-select";

export const powerOfAttorneyOptions: SpMultiSelectOption<string>[] = [
    { id: "empty", label: powerOfAttorneyDescription.empty }, // explicitly, no POA
    { id: "all", label: powerOfAttorneyDescription.all },
    { id: "financial", label: powerOfAttorneyDescription.financial },
    { id: "medic", label: powerOfAttorneyDescription.medic },
    { id: "financial_real", label: powerOfAttorneyDescription.financial_real },
    { id: "guardian", label: powerOfAttorneyDescription.guardian },
];
